// Light pastel diagonal-gradient tints for destination chips.
// Cycling by index across wrapped rows produces a subtle diagonal color pattern.
const CHIP_TINTS = [
  "linear-gradient(135deg, #eaf2fe 0%, #d4e4fc 100%)", // sky blue
  "linear-gradient(135deg, #fef7e6 0%, #fdeac2 100%)", // warm amber
  "linear-gradient(135deg, #fdeef1 0%, #fadbe2 100%)", // soft rose
  "linear-gradient(135deg, #e9f8ef 0%, #d0f0dd 100%)", // mint green
  "linear-gradient(135deg, #f3eefe 0%, #e5dafc 100%)", // lavender
  "linear-gradient(135deg, #e8f7fa 0%, #cfeef5 100%)", // aqua
  "linear-gradient(135deg, #fdf2e9 0%, #fae1cd 100%)", // peach
];

export const chipTint = (i) => CHIP_TINTS[i % CHIP_TINTS.length];
